import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import { useParams } from "react-router-dom";
import imgLogo from "../../assets/images/logo.png";

import Page from "../General/Page";

const PrintAttendenceSheet = (props) => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [selectedMonth, setselectedMonth] = useState("");

  let params = useParams();

  // Get the current month and number of days
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  const [selectWing, setselectWing] = useState("");
  const [selectClass, setselectClass] = useState("");
  const [selectSection, setselectSection] = useState("");

  // Generate an array of days in the month
  const monthDays = Array.from(
    { length: daysInMonth },
    (_, index) => index + 1
  );

  // Generate an array of day names for the current month
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  useEffect(() => {
    document.title = "Monthly Attendence Register";

    setIsUpdated(false);
    setLoading(true);

    setselectedMonth(moment().format("MMMM"));

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 2000,
      Section_Id: props.Section_ID ? props.Section_ID : params.id,
    };

    //console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "Student/SearchStudents",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    //console.log(data);
    axios(api_config)
      .then(function (response) {
        //console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
        setselectWing(
          response.data.ListofRecords[0].SelectedClass?.SelectedWing?.Wing_Name
        );
        setselectClass(
          response.data.ListofRecords[0].SelectedClass?.Class_Name
        );
        setselectSection(
          response.data.ListofRecords[0].SelectedSection?.Section_Name
        );
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [props.Section_ID]);



  const renderEmptyRows = (count) => {
    return Array.from({ length: count }, (_, index) => (
      <tr key={index}>
        <td><span className="opacity-0">www</span></td>
        <td></td>
        <td></td>
        {monthDays != null && monthDays.map((day) => (
          <React.Fragment key={day}>
            <td></td>
            <td></td>
          </React.Fragment>
        ))}
        <td></td>
      </tr>
    ));
  };
  useEffect(() => {
    if (monthDays) {
      document.documentElement.style.setProperty('--total-day-columns', monthDays.length * 2);
    }
  }, [monthDays]);
  const emptyRows = renderEmptyRows(6);
  // Add this function right before your return statement
  const renderTableStructure = () => {
    const tableHeader = (
      <thead>
        <tr>
          <th>Sr#</th>
          <th className="text-nowrap">Reg. No.</th>
          <th className="text-nowrap">Student's Name</th>
          {monthDays.map((day) => (
            <th
              key={day}
              colSpan={2}
              className="day-column"
              style={{ padding: "0" }}
            >
              {day} <br />
              {dayNames[new Date(currentYear, currentMonth, day).getDay()]}
            </th>
          ))}
          <th>Total</th>
        </tr>
      </thead>
    );

    // Calculate a reasonable number of students per page
    const studentsPerPage = 25; // Adjust based on your needs
    const totalPages = Math.ceil(listOfLedger.length / studentsPerPage);

    const pages = [];

    for (let page = 0; page < totalPages; page++) {
      const startIdx = page * studentsPerPage;
      const endIdx = Math.min(startIdx + studentsPerPage, listOfLedger.length);
      const pageStudents = listOfLedger.slice(startIdx, endIdx);

      const tableBody = (
        <tbody>
          {pageStudents.map((item, index) => (
            <tr key={index}>
              <td style={{ fontSize: "13px" }}>{startIdx + index + 1}</td>
              <td style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                {item.Registration_No}
              </td>
              <td style={{ whiteSpace: "nowrap", fontSize: "13px" }}>
                {item.Student_Name}
              </td>
              {monthDays != null && monthDays.map((day) => (
                <React.Fragment key={day}>
                  <td></td>
                  <td></td>
                </React.Fragment>
              ))}
              <td></td>
            </tr>
          ))}
          {page === totalPages - 1 ? emptyRows : null}
        </tbody>
      );

      pages.push(
        <React.Fragment key={`page-${page}`}>
          {page > 0 && <div className="page-break"></div>}
          <table className="table table-sm table-bordered table-print white-space-wrap">
            <colgroup>
              <col style={{ width: "2%" }} />
              <col style={{ width: "6%" }} />
              <col style={{ width: "14%", fontSize: "19px" }} />
              {monthDays.map((day, idx) => (
                <React.Fragment key={`col-${idx}`}>
                  <col style={{ width: `${70 / (monthDays.length * 2)}%` }} />
                  <col style={{ width: `${70 / (monthDays.length * 2)}%` }} />
                </React.Fragment>
              ))}
              <col style={{ width: "4%" }} />
            </colgroup>
            {tableHeader}
            {tableBody}
          </table>
        </React.Fragment>
      );
    }

    return pages;
  };

  // Then in your return statement:
  return (
    <>
      <Page orientation="landscape" size="legal">
        <table className="table table-sm table-bordered table-print white-space-wrap">

          <div className="report-header">
            <table style={{ width: "100%" }}>
              <tr style={{ border: "none" }}>
                <td style={{ width: "50%" }}>
                  <div className="logo">
                    <img src={imgLogo} alt="logo" />
                  </div>
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: "10pt",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <b>Printed on: </b>
                  <span>
                    {moment().format("MMMM Do YYYY, h:mm:ss a")}
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <h3 style={{ fontSize: "13pt" }}>
            Monthly Attendence Register For the Month of {selectedMonth} {selectWing}-{selectClass}-
            {selectSection}
          </h3>
        </table>

        {loading ? (
          <table className="table table-sm table-bordered table-print white-space-wrap">
            <tbody>
              <tr>
                <td className="text-center" colSpan="70">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          renderTableStructure()
        )}

        <div>
          <table
            className="table table-sm table-bordered table-print"
            style={{
              borderCollapse: "collapse",
              border: "transparent",
            }}
          >
            <tbody>
              <tr>
                <td style={{ width: "450px%" }}>
                  No.of Students at the beginning of the month
                </td>
                <td style={{ width: "15%" }}>
                  ____________________
                </td>
                <td style={{ width: "450px%" }}>
                  No of school meetings since
                  <span>June</span>
                  1st.
                </td>
                <td style={{ width: "15%" }}>
                  ____________________
                </td>
              </tr>
              <tr>
                <td>No. of Students struck off during the month</td>
                <td>
                  ____________________
                </td>
                <td>No of school meetings during the month</td>
                <td>
                  ____________________
                </td>
              </tr>
              <tr>
                <td>No. of Students admitted during the month</td>
                <td>
                  ____________________
                </td>
                <td>Total No. of attendance during the month.</td>
                <td>
                  ____________________
                </td>
              </tr>
              <tr>
                <td>No. of Students at the end of the month</td>
                <td>
                  ____________________
                </td>
                <td>Average daily attendance during the month</td>
                <td>
                  ____________________
                </td>
              </tr>
            </tbody>
          </table>
          <table
            className="table table-sm table-bordered table-print mt-5"
            style={{
              borderCollapse: "collapse",
              border: "transparent",
            }}
          >
            <tbody>
              <tr>
                <th style={{ width: "33.3333%" }} className="">
                  Teacher Incharge
                </th>
                <th
                  style={{ width: "33.3333%" }}
                  className="text-center"
                >
                  Checker
                </th>
                <th
                  style={{ width: "33.3333%" }}
                  className="text-end"
                >
                  Head of Wing
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>
    </>
  );
};

export default PrintAttendenceSheet;